import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=03936f29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03936f29"]])

export default __exports__